"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";

import "../../marken/marken.css";

import { TopSectionMarken } from "../../marken/sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BannerImage2 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig2.avif";
import BannerImage3 from "@/assets/auto-verkaufen/AutoeinfachlosBannerBig3.avif";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import { fragenVollmachtAutoverkauf } from "./data";

// Ratgeber SERVERSEITIG rendern (dynamic OHNE die SSR-Abschaltung, Playbook 2.6):
// die sechs "Mehr zum Thema"-Kacheln verlinken u. a. /auto-verkaufen.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function VollmachtAutoverkauf() {
  const [step, setStep] = useState(1);

  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="Vollmacht für den Autoverkauf: Vorlage & Hinweise"
        link="/guides/vollmacht-autoverkauf"
        linkname="Vollmacht Autoverkauf"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/guides/vollmacht-autoverkauf"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Wann du eine Vollmacht brauchst"
              leftText={
                <>
                  <p>
                    Nicht immer kann man beim Autoverkauf persönlich anwesend
                    sein, etwa bei Krankheit, Auslandsaufenthalt oder
                    Zeitmangel. In solchen Fällen kann eine Vollmacht für den
                    Autoverkauf helfen.
                  </p>
                  <p>
                    Doch was genau darf die bevollmächtigte Person tun? Welche
                    Risiken bestehen? Und worauf musst du achten, damit alles
                    rechtssicher abläuft?
                  </p>
                  <p>
                    Hier erfährst du Schritt für Schritt, wie du eine Vollmacht
                    für den Autoverkauf korrekt erstellst – und wann der Verkauf
                    über Autoeinfachlos die einfachere Lösung ist.
                  </p>
                </>
              }
              rightFirstTitle="Was ist eine Vollmacht beim Autoverkauf?"
              rightFirstText={
                <>
                  <p>
                    Eine Vollmacht erlaubt es einer anderen Person, rechtlich
                    verbindlich in deinem Namen zu handeln.
                  </p>
                  <p>
                    Beim Autoverkauf bedeutet das: Die bevollmächtigte Person
                    darf das Fahrzeug verkaufen, den Kaufvertrag unterzeichnen
                    und die Übergabe durchführen, als wärst du selbst anwesend.
                  </p>
                  <p>Sie ist besonders praktisch, wenn:</p>
                  <ul className="custom-unordered-list">
                    <li>
                      du nicht vor Ort bist, z. B. im Ausland oder beruflich
                      verhindert,
                    </li>
                    <li>
                      du möchtest, dass ein Familienmitglied oder Freund den
                      Verkauf übernimmt,
                    </li>
                    <li>
                      du dein Auto über eine dritte Person oder einen Händler
                      abwickeln lässt.
                    </li>
                  </ul>

                  <h3>Wann ist eine Vollmacht für den Autoverkauf nötig?</h3>
                  <p>
                    Eine Vollmacht ist immer dann sinnvoll, wenn der
                    Fahrzeughalter nicht selbst beim Verkauf anwesend ist.
                  </p>
                  <p>Das gilt z. B. in folgenden Situationen:</p>
                  <ul className="custom-unordered-list">
                    <li>Verkauf durch Partner oder Verwandte</li>
                    <li>
                      Verkauf durch Bevollmächtigte im Auftrag (z. B.
                      Kommissionsverkauf)
                    </li>
                    <li>
                      Übergabe an Käufer oder Händler, wenn der Halter nicht
                      erscheinen kann
                    </li>
                    <li>Abmeldung oder Ummeldung durch eine andere Person</li>
                  </ul>
                  <p>
                    Auch bei einem Verkauf über Autoeinfachlos kann auf Wunsch
                    eine Vollmacht genutzt werden, etwa wenn du keine Zeit hast,
                    das Fahrzeug persönlich zu übergeben.
                  </p>
                </>
              }
              rightSecondTitle="Was muss in der Vollmacht stehen?"
              rightSecondText={
                <>
                  <p>
                    Damit die Vollmacht gültig ist, muss sie klar und
                    vollständig formuliert sein. Sie sollte folgende Angaben
                    enthalten:
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      Vollmachtgeber (Fahrzeughalter): Name, Adresse,
                      Geburtsdatum
                    </li>
                    <li>Bevollmächtigte Person: Name, Adresse, Geburtsdatum</li>
                    <li>
                      Fahrzeugdaten: Marke, Modell, Kennzeichen, FIN
                      (Fahrgestellnummer)
                    </li>
                    <li>
                      Umfang der Vollmacht: z. B. Verkauf,
                      Vertragsunterzeichnung, Übergabe, Zahlung
                    </li>
                    <li>
                      Gültigkeitsdauer (optional, z. B. bis zum erfolgreichen
                      Verkauf)
                    </li>
                    <li>Ort, Datum, Unterschrift des Halters</li>
                  </ul>

                  <p>
                    <strong>Tipp:</strong> Eine handschriftliche Unterschrift
                    ist Pflicht, digitale Vollmachten sind nur in Ausnahmefällen
                    gültig.
                  </p>

                  <p>
                    <strong>
                      Muster-Vorlage für eine Vollmacht Autoverkauf
                    </strong>
                  </p>
                  <p>
                    Diese Vorlage kannst du individuell anpassen. Wichtig ist,
                    dass beide Parteien die Vollmacht unterschreiben und sich
                    ausweisen können.
                  </p>
                </>
              }
            />

            <div className="Banner-sections">
              <BildTextInfo
                image={BannerImage3}
                revert
                h2
                isBig
                fontSize="36px"
                title="Welche Risiken bestehen beim Autoverkauf mit Vollmacht?"
                alt="Risiken beim Autoverkauf mit Vollmacht"
                text={
                  <>
                    <p>
                      Auch wenn eine Vollmacht bequem ist, birgt sie rechtliche
                      Risiken, vor allem bei Missverständnissen oder
                      Betrugsfällen:
                    </p>
                    <ul className="custom-unordered-list">
                      <li>Der Bevollmächtigte verkauft das Auto unter Wert</li>
                      <li>Zahlung wird nicht korrekt abgewickelt</li>
                      <li>Käufer zweifeln die Echtheit der Vollmacht an</li>
                      <li>Unklare Absprachen führen zu Streit</li>
                    </ul>

                    <p>
                      Deshalb gilt: Nur Personen bevollmächtigen, denen du
                      vollständig vertraust oder den Verkauf über eine geprüfte
                      Plattform wie Autoeinfachlos abwickeln.
                    </p>
                  </>
                }
              />

              <BildTextInfo
                image={BannerImage2}
                h2
                isBig
                fontSize="36px"
                title="Vollmacht beim Verkauf über Autoeinfachlos"
                alt="Vollmacht und sicherer Autoverkauf"
                text={
                  <>
                    <p>
                      Wenn du dein Auto über Autoeinfachlos verkaufst, ist der
                      Ablauf transparent, sicher und ohne juristische
                      Fallstricke.
                    </p>
                    <p>
                      Du kannst auf Wunsch eine Person deines Vertrauens
                      bevollmächtigen, die das Fahrzeug an Händler übergibt –
                      der gesamte Prozess bleibt dokumentiert und rechtssicher.
                    </p>

                    <p>
                      <strong>Deine Vorteile:</strong>
                    </p>
                    <ul className="custom-unordered-list">
                      <li>Verkauf über 5.000 geprüfte Händler</li>
                      <li>
                        Keine Gewährleistungspflichten oder Haftungsrisiken
                      </li>
                      <li>Rechtssichere Verträge und Zahlung</li>
                      <li>Auf Wunsch Abmeldung und Abholung inklusive</li>
                      <li>
                        Vollmacht nur nötig, wenn du selbst nicht anwesend bist
                      </li>
                    </ul>

                    <p>
                      So kannst du dein Fahrzeug bequem verkaufen, auch wenn du
                      keine Zeit hast oder im Ausland bist.
                    </p>
                  </>
                }
              />
            </div>

            <HäufigeFragen
              title="FAQ – Häufige Fragen zur Vollmacht Autoverkauf"
              fragen={fragenVollmachtAutoverkauf}
              image={FAQImage}
              removePaddingBottom
            />

            <div style={{ paddingTop: "120px" }}>
              <Ratgeber
                title="Mehr zum Thema Vollmacht Autoverkauf"
                kaputtesAuto
                unfallAuto
                autoExport
                autoVerkaufen
                autoBewerten
                listenpreisBerechnen
              />
            </div>

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Auto mit Vollmacht verkaufen - sicher nur mit Vertrauen"
                alt="Auto mit Vollmacht sicher verkaufen"
                text={
                  <>
                    <p>
                      Eine Vollmacht für den Autoverkauf ist praktisch, aber sie
                      sollte immer mit Bedacht eingesetzt werden.
                    </p>
                    <p>
                      Wenn du Zeit sparen und rechtliche Risiken vermeiden
                      willst, ist der Verkauf über Autoeinfachlos die sichere
                      Alternative.
                    </p>
                    <p>
                      👉{" "}
                      <Link className="link" href="/auto-bewerten">
                        Jetzt kostenlos Fahrzeugwert ermitteln und Verkauf
                        sicher abwickeln - mit oder ohne Vollmacht.
                      </Link>
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner link="/auto-bewerten" />
        </div>
      )}
    </div>
  );
}

export default VollmachtAutoverkauf;
